import { useDashboard } from "../../providers/dashboard";
import SelectorEntry from "./selector-entry";

const Selector = ({ fetchDetail }) => {
    const { state } = useDashboard();

    if (!state.selectedCarHistory) return null;

    return (
        <div
            className="space-y-2"
        >
            {
                state.selectedCarHistory.map(arr => {
                    return (
                        <SelectorEntry
                            entry={arr}
                            onClick={fetchDetail}
                        />
                    )
                })
            }
        </div>
    )
}

export default Selector;